import * as React from "react"
import { useState, useEffect } from "react"
import * as styles from "./style.module.css"
import { useFuneralAnalytics } from "../../../provider"

// Floating "back to top" control. Appears after the page is scrolled down and
// smooth-scrolls to the top on click. SSR-safe: renders nothing until the client
// scroll listener marks it visible, so the server and first hydration render match.
const BackToTop = () => {
  const { site } = useFuneralAnalytics()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400)
    window.addEventListener("scroll", onScroll, { passive: true })
    onScroll()
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  if (!visible) return null

  return (
    <button
      type="button"
      className={styles.button}
      aria-label="Back to top"
      onClick={() => {
        site.backToTop()
        window.scrollTo({ top: 0, behavior: "smooth" })
      }}
    >
      <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
        <path
          d="M7 14l5-5 5 5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  )
}

export default BackToTop
